var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"contract"},[_vm._v("В ближайшее время договор будет добавлен")])
}
var staticRenderFns = []

export { render, staticRenderFns }